var position = [
    {
        value: 'owner',
        label: 'Business Owner*in'
    },
    {
        value: 'creator',
        label: 'Creator*in'
    },
    {
        value: 'inhouse',
        label: 'In-House Produzent*in oder Marketer'
    },
    {
        value: 'industry',
        label: 'Podcast-Industrie-Professional'
    },
];
var commitment = [
    {
        value: '10_minutes',
        label: 'Zehn Minuten'
    },
    {
        value: '15_minutes',
        label: 'Viertelstunde'
    },
    {
        value: '30_minutes',
        label: 'Halbe Stunde'
    },
    {
        value: '1_hour',
        label: 'Eine Stunde'
    },
    {
        value: '2_hours',
        label: 'Zwei Stunden'
    },
    {
        value: '1_day',
        label: 'Einen Tag'
    },
    {
        value: '2_days',
        label: 'Zwei Tage'
    },
    {
        value: '3_days',
        label: 'Drei Tage'
    },
    {
        value: '5_days',
        label: 'Fünf Tage'
    },
    {
        value: '1_week',
        label: 'Eine Woche'
    },
    {
        value: '2_weeks',
        label: 'Zwei Wochen'
    },
];
var expansion = [
    {
        value: 'pre_launch',
        label: 'vor dem Launch'
    },
    {
        value: 'lt_1k',
        label: 'bis zu 1.000 Hörer*innen'
    },
    {
        value: 'lt_20k',
        label: 'bis zu 20.000 Hörer*innen'
    },
    {
        value: 'lt_50k',
        label: 'bis zu 50.000 Hörer*innen'
    },
    {
        value: 'lt_200k',
        label: 'bis zu 200.000 Hörer*innen'
    },
    {
        value: 'gt_200k',
        label: 'mehr als 200.000 Hörer*innen'
    },
];
var investment = [
    {
        value: 'none',
        label: 'ohne'
    },
    {
        value: 'lt_50',
        label: 'bis zu 50 Euro'
    },
    {
        value: 'lt_100',
        label: 'bis zu 100 Euro'
    },
    {
        value: 'lt_1k',
        label: 'bis zu 1.000 Euro'
    },
    {
        value: 'lt_10k',
        label: 'bis zu 10.000 Euro'
    },
    {
        value: 'lt_100k',
        label: 'bis zu 100.000 Euro'
    },
    {
        value: 'gt_100k',
        label: 'mehr als 100.000 Euro'
    },
];
var importance = [
    {
        value: 'none',
        label: 'nicht wichtig (0 Punkte)'
    },
    {
        value: 'low',
        label: 'halbwegs wichtig (1 Punkt)'
    },
    {
        value: 'medium',
        label: 'ziemlich wichtig (2 Punkte)'
    },
    {
        value: 'high',
        label: 'extrem wichtig (3 Punkte)'
    },
];
var relevance = [
    {
        value: 'essential',
        label: 'Essential'
    },
    {
        value: 'optional',
        label: 'Optional'
    },
];
var language = [
    {
        value: 'de',
        label: 'Deutsch'
    },
];
var referrer = [
    {
        value: 'search_engine',
        label: 'Treffer in der Suchmaschine'
    },
    {
        value: 'social_media',
        label: 'Soziale Medien'
    },
    {
        value: 'advertisement',
        label: 'Werbeanzeige'
    },
    {
        value: 'recommendation',
        label: 'Empfehlung von Kolleg*in'
    },
    {
        value: 'podcast',
        label: 'Podcast'
    },
    {
        value: 'magazine',
        label: 'Magazinbeitrag'
    },
    {
        value: 'newsletter',
        label: 'Erwähnung in einem Newsletter'
    },
    {
        value: 'conference',
        label: 'Konferenz'
    },
    {
        value: 'workshop',
        label: 'Workshop'
    },
    {
        value: 'unknown',
        label: 'Weiß nicht mehr'
    },
];
var frequencies = [
    {
        value: 'monthly',
        label: 'Monatlich',
        details: 'Monatliche Abrechnung'
    },
    {
        value: 'annual',
        label: 'Jährlich (17% gespart)',
        details: 'Jährliche Abrechnung'
    },
];
export { commitment, expansion, importance, investment, language, referrer, position, relevance, frequencies, };
